// Logos
import logo from "branchAndBrandSpecific/utils/brandVariables/assets/logitech/logitechg.svg";
import logoSmall from "branchAndBrandSpecific/utils/brandVariables/assets/logitech/logitech-g-sm.svg";
// Covers
import challengesCover from "@/assets/cover/challenges_logitechg.webp";
import newsCover from "@/assets/cover/news_logitechg.webp";

export const Logitechg_brandVariables = {
  siteTitle: "Logitech G",
  siteIcon: logoSmall,
  name: "Logitech G",
  name_small: "Logitech G",
  logos: {
    large: logo,
    white: logo,
    small: logoSmall,
    medium: null,
    alt_text: "Logitech G logo",
    profile: logoSmall,
  },
  cover: {
    challenges: challengesCover,
    news: newsCover,
  },
  tenantId: "logitechg-7vvzz",
  brandTheme: "logitech", // Theme of the brand
  site: "logitechg.iplay.dk", // Live url of site
  authMethod: "email", // Only needed for events, gives user set options to manualy sign up, options are:  email | phone
  defaultCountryCode: "SV", // Only needed for retail platforms | For initial phone number | Changes all auth methods`
  defaultLanguage: "en",
  brandStoreExtension: "", // Only needed for retail platforms | Extension used for email
  brandValue: "LOGITECH", // Only needed for retail platforms | Brand value needed for BE related functions
  brandIntials: "", // gets added after the username, to drasticaly descrease chance of duplicate usernames across different apps | Only needed for event platforms
  defaultNavigateUrl: "/",
  eventHasAutoQrSignup: false,
  hasSubClients: true,
  subClientsForOverviews: [""], // string[] of clients used to fetch multiple types of clients for overview pages
  autoJoinChallenge: true,
  hasFeature: {
    notifications: false,
    themes: false,
    connections: false,
    achievements: false,
    quickSignUp: false,
    messages: false,
    teams: false,
    news: true,
    challenges: true,
    singleChallenge: true,
    preferences: false,
    friends: false,
    zones: false,
    feed: true,
    posts: false,
    winners: false,
    qrSignUp: true,
    manualSubmissions: false,
    landing: true,
    login: true,
    haslanguagePicker: true,
    getstarted: false,
    hero: false,
    search: false,
    routes: true,
    dailytasks: false,
    games: false,
    treasure_hunt: false,
    activities: false,
    changePassword: false,
    feedback: false,
    events: false,
    precisionGame: true,
  },
  hasAuth: {
    steam: false,
    bnet: false,
    quickSignUp: true,
    google: false,
    discord: false,
    twitch: false,
  },
  layout: {
    challenge: "default",
  },
  event: {
    forcedCredentialPopup: "",
    eventCode: "instore", // Only needed for event platforms
    collectionForSubmissions: "",
    documentForSubmissions: "",
    isEvent: true,
    spacecoins_redirect: false,
  },
  hasCreate: {
    studio: false,
    challenges: true,
    news: true,
  },
};
